/** Escassez da Black em Dobro: chamadas e contador que reinicia todo dia à meia-noite (Brasília). */
export const BLACK_ULTIMOS_DIAS = "ÚLTIMO DIA";
export const BLACK_CTA_VENDA = "Garantir minha vaga";

const DIA = 86_400_000;
const BRT = 3 * 3_600_000; // Brasília = UTC-3 fixo

/** Próxima meia-noite em Brasília (fim do dia corrente). */
export function fimDoDiaBrasilia(now: number): number {
  return Math.floor((now - BRT) / DIA) * DIA + DIA + BRT;
}

export function partesContador(ms: number) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

/** Marcos fixos do contador (nenhum ativo): desde 30/10 23h59 o contador zera todo dia à meia-noite de Brasília. */
export const BLACK_MARCOS_CONTADOR: number[] = [];

/** Fim do contador: próximo marco fixo ainda futuro; sem marcos, a meia-noite de Brasília. */
export function fimContadorBlack(now: number): number {
  const marco = BLACK_MARCOS_CONTADOR.find((m) => m > now);
  return marco ?? fimDoDiaBrasilia(now);
}
